import { Wrapper } from '../../components/Containers';

const Home = () => (
  <Wrapper applyBreakpoints className='not found'>
    Not found
  </Wrapper>
);
export default Home;
